import { Link } from "react-router-dom";
import { Instagram, Facebook } from "lucide-react";
import { ASSETS, SOCIALS } from "@/lib/assets";

const links = [
  { label: "Privacy", to: "/privacy", internal: true },
  { label: "Submissions", to: "/submissions", internal: true },
];

export default function Footer() {
  return (
    <footer
      data-testid="global-footer"
      className="relative z-10 border-t border-slate/20 bg-charcoal"
    >
      <div className="mx-auto max-w-[1400px] px-4 md:px-12 lg:px-16 py-16">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-10">
          <Link to="/" className="flex items-center gap-4">
            <img src={ASSETS.labelLogo} alt="Sorrow & Serenity" className="h-16 w-16 object-contain" />
            <div className="font-display text-softwhite text-lg leading-tight">
              SORROW &amp; SERENITY
              <span className="block font-label text-slate text-xs tracking-[0.3em] mt-1">MUSIC LABEL</span>
            </div>
          </Link>

          <div className="flex flex-wrap items-center gap-x-8 gap-y-4">
            {links.map((l) => (
              <Link
                key={l.label}
                to={l.to}
                data-testid={`footer-link-${l.label.toLowerCase()}`}
                className="font-label uppercase tracking-[0.18em] text-xs text-slate hover:text-softwhite transition-colors duration-300"
              >
                {l.label}
              </Link>
            ))}
            <a
              href={SOCIALS.instagram}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram"
              className="flex items-center gap-2 font-label uppercase tracking-[0.18em] text-xs text-slate hover:text-crimson-bright transition-colors duration-300"
            >
              <Instagram size={15} />
              Instagram
            </a>
            <a
              href={SOCIALS.facebook}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-facebook"
              className="flex items-center gap-2 font-label uppercase tracking-[0.18em] text-xs text-slate hover:text-crimson-bright transition-colors duration-300"
            >
              <Facebook size={15} />
              Facebook
            </a>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-slate/10 flex flex-col sm:flex-row justify-between gap-3 text-slate/70 text-xs font-label tracking-wider">
          <span>© 2026 Sorrow &amp; Serenity Music. All Rights Reserved.</span>
          <span className="uppercase">Balancing Crushing Weight With Atmospheric Serenity.</span>
        </div>
      </div>
    </footer>
  );
}
